import { ospThemes } from "@ospweb/sdk-ui";
import EdgenDrawerCallable from "../EdgenDrawerCallable";
import { TAItems } from "../PortfolioTimeline";
import { TAModalCallableParams } from "./types";
import { AgentReport } from "@/src/features/api/memberApi";

interface TAModalContentProps {
  data: AgentReport;
  onClose: () => void;
}

const TAModalContent = (params: TAModalContentProps) => {
  const { data, onClose } = params;
  return (
    <TAItems
      item={data}
      isExpanded={true}
      isPC={false}
      variant="modal"
      modalParams={{ onClose }}
    />
  );
};

export const TAModalCallable = async (
  params: TAModalCallableParams,
): Promise<boolean> => {
  const { onClose, data } = params;

  const handleClose = () => {
    onClose?.();
    EdgenDrawerCallable.update({ isOpen: false });
  };

  const result = await EdgenDrawerCallable.call({
    placement: "bottom",
    width: "100%",
    height: "calc(100% - 54px)",
    isHiddenClose: true,
    isMask: false,
    contentClassName: "pb-0 no-scrollbar",
    onClose,
    styles: {
      body: {
        padding: "0 16px 0 16px",
        backgroundColor: ospThemes.colors.background_solid_secondary,
        ["scrollbarWidth" as any]: "none",
      },
    },
    children: <TAModalContent data={data} onClose={handleClose} />,
  });

  return result;
};
